import React from 'react';
import { connect } from 'react-redux';
import Header from '~components/header';
import Navigation from '~components/navigation';
import Warning from './warning';
import BlurMob from '~img/blur-mob.jpg';
import Blur from '~img/blur.jpg';

function BlockedPage({ isMobile }) {
    React.useEffect(() => {
        const header = document.getElementsByTagName('header')[0];
        function cleanOverflow() {
            document.documentElement.style.overflow = 'auto';
            document.documentElement.style.paddingRight = '0';
            header.style.width = '100%';
        }
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.paddingRight = `${isMobile ? '0' : '15'}px`;
        header.style.width = `calc(100vw - ${isMobile ? '0' : '15'}px)`;
        return cleanOverflow;
    });

    const isNoScroll = window.location.href.search('/map') !== -1;
    return (
        <React.Fragment>
            <Header disabled>
                <Navigation isMobile={isMobile} />
            </Header>
            <div className={`main${isNoScroll ? ' no-scroll' : ''}`}>
                <Warning />
                <div className="main-container" style={{ padding: 0 }}>
                    <img src={isMobile ? BlurMob : Blur} alt="" />
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    isMobile: state.ui.device === 'mobile',
});

export default connect(mapStateToProps)(BlockedPage);
export { BlockedPage };



// WEBPACK FOOTER //
// ./src/routes/blocked-page/index.js